import { FC, memo, useCallback, useMemo } from 'react';
import { FlexColumn } from '../basic-flex/flex-column';
import { SkioldTextField } from '../skiold-components/skiold-text-field/skiold-text-field';
import React from 'react';
import { localized } from 'shared/state/i18n/i18n';
import { FormRow } from '../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';
import { SkioldFormsWrapper } from '../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { FormTitle } from './form-title';
import { useOwnerContext } from './create-site-context-provider';
import { SkioldFormInput } from '../skiold-components/skiold-input/skiold-form-input';

interface Props {}

export const SiteOwnerInformation: FC<Props> = memo(() => {
	const { fields, setField } = useOwnerContext();

	const onNameChanged = useCallback((text: string) => setField('name', text), [setField]);
	const onAddressChanged = useCallback((text: string) => setField('address', text), [setField]);
	const onPostNumberChanged = useCallback((text: string) => setField('postNumber', text), [setField]);
	const onCityChanged = useCallback((text: string) => setField('city', text), [setField]);
	const onCvrNrChanged = useCallback((text: string) => setField('cvrNr', text), [setField]);

	const formRows: Array<FormRow> = useMemo(() => {
		return new Array<FormRow>(
			{
				name: localized('ownerName'),
				component: <SkioldFormInput text={fields.name} onChangeText={onNameChanged} />,
			},
			{
				name: localized('ownerAddress'),
				component: <SkioldFormInput text={fields.address} onChangeText={onAddressChanged} />,
			},
			{
				name: localized('ownerZipCode'),
				component: (
					<SkioldFormInput useAsInterger={true} text={fields.postNumber} onChangeText={onPostNumberChanged} />
				),
			},
			{
				name: localized('ownerCity'),
				component: <SkioldFormInput text={fields.city} onChangeText={onCityChanged} />,
			},
			{
				name: localized('cvRnum'),
				component: <SkioldFormInput useAsInterger={true} text={fields.cvrNr} onChangeText={onCvrNrChanged} />,
			},
		);
	}, [fields, onNameChanged, onAddressChanged, onPostNumberChanged, onCityChanged, onCvrNrChanged]);

	return (
		<FlexColumn>
			<FormTitle title={localized('Owner')} />
			<SkioldFormsWrapper formRows={formRows} containerClassName="wrapper-container" />
		</FlexColumn>
	);
});
